import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    action: "#",
    method: "POST"
};
const _hoisted_2 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_3 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Specialist Roles\n          ")
], -1);
const _hoisted_5 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_6 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is this a Highway Worker Role? *")
], -1);
const _hoisted_7 = { class: "mt-4 space-y-4" };
const _hoisted_8 = { class: "flex items-start" };
const _hoisted_9 = { class: "h-5 flex items-center" };
const _hoisted_10 = ["disabled", "checked"];
const _hoisted_11 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "highwayWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_12 = { class: "flex items-start" };
const _hoisted_13 = { class: "h-5 flex items-center" };
const _hoisted_14 = ["disabled", "checked"];
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "highwayWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = {
    key: 0,
    class: "text-sm text-red-500"
};
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", { class: "mb-1" }, "The following wording will appear on the Offer Contract:", -1);
const _hoisted_19 = /*#__PURE__*/ _createElementVNode("p", null, "In addition to your normal hours of work you are required to form part of your team’s call-out rota to deal with emergencies out of hours.  You are required to attend such call-outs as and when requested by the Company.", -1);
const _hoisted_20 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_21 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is this a Mobile Worker Role? *")
], -1);
const _hoisted_22 = { class: "mt-4 space-y-4" };
const _hoisted_23 = { class: "flex items-start" };
const _hoisted_24 = { class: "h-5 flex items-center" };
const _hoisted_25 = ["disabled", "checked"];
const _hoisted_26 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "mobileWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_27 = { class: "flex items-start" };
const _hoisted_28 = { class: "h-5 flex items-center" };
const _hoisted_29 = ["disabled", "checked"];
const _hoisted_30 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "mobileWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_31 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, "\n              *If yes, the word mobile should be included in the job title.\n            ", -1);
const _hoisted_33 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_34 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("p", null, "Is this a Hybrid Worker Role? *")
], -1);
const _hoisted_35 = { class: "mt-4 space-y-4" };
const _hoisted_36 = { class: "flex items-start" };
const _hoisted_37 = { class: "h-5 flex items-center" };
const _hoisted_38 = ["disabled", "checked"];
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "hybridWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_40 = { class: "flex items-start" };
const _hoisted_41 = { class: "h-5 flex items-center" };
const _hoisted_42 = ["disabled", "checked"];
const _hoisted_43 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "hybridWorker",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_44 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_45 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-500" }, "\n              *Please check with your HR Manager whether Hybrid Working applies;\n              if so, this will be noted in the job offer\n            ", -1);
const _hoisted_46 = { class: "grid grid-cols-3 gap-6 sm:border-t sm:border-gray-200 sm:pt-5 mt-4" };
const _hoisted_47 = { class: "col-span-6" };
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("p", { class: "block text-sm font-medium text-gray-700" }, "\n                Will the employee be subject to Collective Bargaining, if so\n                please provide the name of the Collective Bargaining Arrangement\n                as this will be included in their Contract of Employment: *\n              ", -1);
const _hoisted_49 = { class: "mt-4 space-y-4" };
const _hoisted_50 = { class: "flex items-start" };
const _hoisted_51 = { class: "h-5 flex items-center" };
const _hoisted_52 = ["disabled", "checked"];
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "collectiveBargaining",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_54 = { class: "flex items-start" };
const _hoisted_55 = { class: "h-5 flex items-center" };
const _hoisted_56 = ["disabled", "checked"];
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "collectiveBargaining-no",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_58 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_59 = { key: 0 };
const _hoisted_60 = /*#__PURE__*/ _createElementVNode("label", {
    class: "block text-sm font-medium text-gray-700 mt-4",
    for: "collectiveBargaining-input"
}, "Name of Collective Bargaining Arrangement *", -1);
const _hoisted_61 = ["value", "disabled"];
const _hoisted_62 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_63 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_64 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("form", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_5, [
                        _hoisted_6,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("input", {
                                        id: "radio-button-highwayWorker-yes",
                                        value: "Yes",
                                        name: "highwayWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.highwayWorker === 'Yes',
                                        onChange: _cache[0] || (_cache[0] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.highwayWorker.$touch()))
                                    }, null, 42, _hoisted_10)
                                ]),
                                _createTextVNode(),
                                _hoisted_11
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("input", {
                                        id: "radio-button-securityRole-no",
                                        value: "No",
                                        name: "highwayWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.highwayWorker === 'No',
                                        onChange: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.highwayWorker.$touch()))
                                    }, null, 42, _hoisted_14)
                                ]),
                                _createTextVNode(),
                                _hoisted_15
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.highwayWorker.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n                * " + _toDisplayString(_ctx.v$.formData.highwayWorker.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        (_ctx.formData.highwayWorker === 'Yes')
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _hoisted_18,
                                _createTextVNode(),
                                _hoisted_19
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, [
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("input", {
                                        id: "radio-button-mobileWorker-yes",
                                        value: "Yes",
                                        name: "mobileWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.mobileWorker === 'Yes',
                                        onChange: _cache[4] || (_cache[4] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.mobileWorker.$touch()))
                                    }, null, 42, _hoisted_25)
                                ]),
                                _createTextVNode(),
                                _hoisted_26
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_27, [
                                _createElementVNode("div", _hoisted_28, [
                                    _createElementVNode("input", {
                                        id: "radio-button-securityRole-no",
                                        value: "No",
                                        name: "mobileWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.mobileWorker === 'No',
                                        onChange: _cache[6] || (_cache[6] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.mobileWorker.$touch()))
                                    }, null, 42, _hoisted_29)
                                ]),
                                _createTextVNode(),
                                _hoisted_30
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.mobileWorker.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_31, "\n                * " + _toDisplayString(_ctx.v$.formData.mobileWorker.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _hoisted_32
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_33, [
                        _hoisted_34,
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("div", _hoisted_36, [
                                _createElementVNode("div", _hoisted_37, [
                                    _createElementVNode("input", {
                                        id: "radio-button-hybridWorker-yes",
                                        value: "Yes",
                                        name: "hybridWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.hybridWorker === 'Yes',
                                        onChange: _cache[8] || (_cache[8] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.hybridWorker.$touch()))
                                    }, null, 42, _hoisted_38)
                                ]),
                                _createTextVNode(),
                                _hoisted_39
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_40, [
                                _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("input", {
                                        id: "radio-button-securityRole-no",
                                        value: "No",
                                        name: "hybridWorker",
                                        type: "radio",
                                        class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        checked: _ctx.formData.hybridWorker === 'No',
                                        onChange: _cache[10] || (_cache[10] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                        onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.hybridWorker.$touch()))
                                    }, null, 42, _hoisted_42)
                                ]),
                                _createTextVNode(),
                                _hoisted_43
                            ]),
                            _createTextVNode(),
                            (_ctx.v$.formData.hybridWorker.$errors.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_44, "\n                * " + _toDisplayString(_ctx.v$.formData.hybridWorker.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]),
                        _createTextVNode(),
                        _hoisted_45
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_46, [
                        _createElementVNode("div", _hoisted_47, [
                            _hoisted_48,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("input", {
                                            id: "radio-button-collectiveBargaining-yes",
                                            value: "Yes",
                                            name: "collectiveBargaining",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.collectiveBargaining === 'Yes',
                                            onChange: _cache[12] || (_cache[12] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.collectiveBargaining.$touch()))
                                        }, null, 42, _hoisted_52)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_53
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_54, [
                                    _createElementVNode("div", _hoisted_55, [
                                        _createElementVNode("input", {
                                            id: "radio-button-collectiveBargaining-no",
                                            value: "No",
                                            name: "collectiveBargaining",
                                            type: "radio",
                                            class: _normalizeClass(["focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer", {
                                                    'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                                }]),
                                            disabled: _ctx.showApprovalSteps,
                                            checked: _ctx.formData.collectiveBargaining === 'No',
                                            onChange: _cache[14] || (_cache[14] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleRadioChange && _ctx.handleRadioChange(...args))),
                                            onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.collectiveBargaining.$touch()))
                                        }, null, 42, _hoisted_56)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_57
                                ]),
                                _createTextVNode(),
                                (_ctx.v$.formData.collectiveBargaining.$errors.length)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_58, "\n                  * " + _toDisplayString(_ctx.v$.formData.collectiveBargaining.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            (_ctx.formData.collectiveBargaining === 'Yes')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                    _hoisted_60,
                                    _createTextVNode(),
                                    _createElementVNode("input", {
                                        id: "collectiveBargaining-input",
                                        value: _ctx.formData.collectiveBargainingText,
                                        type: "text",
                                        name: "collectiveBargainingText",
                                        autocomplete: "email",
                                        class: _normalizeClass(["mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md", {
                                                'bg-gray-200 border-none cursor-not-allowed': _ctx.showApprovalSteps,
                                            }]),
                                        disabled: _ctx.showApprovalSteps,
                                        onInput: _cache[16] || (_cache[16] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                    }, null, 42, _hoisted_61),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.collectiveBargainingText.$errors.length)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_62, "\n                  *\n                  " + _toDisplayString(_ctx.v$.formData.collectiveBargainingText.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ]))
                                : _createCommentVNode("", true)
                        ])
                    ])
                ])
            ])
        ]),
        _createTextVNode(),
        (!_ctx.showApprovalSteps)
            ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                _createElementVNode("button", {
                    class: "mr-2 bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500",
                    onClick: _cache[17] || (_cache[17] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleResetForm && _ctx.handleResetForm(...args)), ["prevent"]))
                }, "\n        Reset Form\n      "),
                _createTextVNode(),
                _createElementVNode("button", {
                    disabled: _ctx.v$.$invalid,
                    type: "submit",
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[18] || (_cache[18] =
                        //@ts-ignore
                        (...args) => (_ctx.handleSave && _ctx.handleSave(...args)))
                }, "\n        Next\n      ", 8, _hoisted_64)
            ]))
            : _createCommentVNode("", true)
    ]));
}
